/*
 *    Copyright (c) 2018-2025, fwpt All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * Redistributions of source code must retain the above copyright notice,
 * this list of conditions and the following disclaimer.
 * Redistributions in binary form must reproduce the above copyright
 * notice, this list of conditions and the following disclaimer in the
 * documentation and/or other materials provided with the distribution.
 * Neither the name of the pig4cloud.com developer nor the names of its
 * contributors may be used to endorse or promote products derived from
 * this software without specific prior written permission.
 * Author: fwpt
 */

import request from '@/router/axios'
import api from "@/api/projectApi";

export function doCheckExcle(fileName) {
  return request({
    url: api.intfDownload.checkDownLoadUrl,
    method: 'post',
    isLoading: true,
    data:{fileName:fileName},
    modalStrictly: true,
  })
}

export function doDownLoadExcle(url,query) {
  return  request({
    url: url,
    method: 'post',
    data:query,
    isLoading: true,
    modalStrictly: true,
  })
}

export function doDownLoadExcleWithoutRecord(url,query) {
  return  request({
    url: url,
    method: 'post',
    data:query,
    isLoading: true,
    modalStrictly: true,
    responseType: 'blob'
  })
}
export function getBlob(res,fileName) {
  const href = URL.createObjectURL(res.data)
  const box = document.createElement('a')
  if (fileName) {
    box.download = fileName
  }
  box.href = href
  box.click()
}



